import { render, staticRenderFns } from "./MaskedInput.vue?vue&type=template&id=bb20f1a2&"
import script from "./MaskedInput.vue?vue&type=script&lang=js&"
export * from "./MaskedInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports